import moment from "moment";
import { useEffect, useState } from "react";
import shijian from '@assets/shijian.svg'

export default function Index({ updateTime }: {
    updateTime: number,
}) {
    const [timeDiff, setTimeDiff] = useState<string>('');
    useEffect(() => {
        const time = moment.unix(updateTime);
        const day = moment().diff(time, 'days');
        const h = moment().diff(time, 'hours');
        const m = moment().diff(time, 'minutes');
        
        if (day > 24) {
            setTimeDiff(`${day}days`)
        } else if (h > 0) {
            setTimeDiff(`${h}hrs`)
        } else if (m > 0) {
            setTimeDiff(`${m}mins`)
        } else {
            setTimeDiff('')
        }

    }, [updateTime])
    return <>{timeDiff != '' && <div className="updated">
        <img src={shijian} /> Updated {timeDiff} ago
    </div>}</>
}